var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDomain = function SvgDomain(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 47.139 18.67"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m40.224 18.17-1.088-9.568-1.081 9.568h-3.76L32.527 6.82 31.701.5h2.917l1.549 13 1.55-13h2.83l1.549 13 1.55-13h2.925l-.826 6.337-1.76 11.332Zm-15.566 0L23.571 8.6l-1.08 9.568H18.73l-1.767-11.35L16.136.5h2.916l1.549 13 1.55-13h2.829l1.549 13 1.55-13h2.924l-.827 6.337-1.758 11.332Zm-15.565 0L8.006 8.602 6.925 18.17H3.164L1.397 6.82.571.5h2.917l1.55 13 1.55-13h2.829l1.55 13 1.549-13h2.926l-.828 6.337-1.758 11.332Z"
  })));
};
export default SvgDomain;